import { render, staticRenderFns } from "./RadioQuestion.vue?vue&type=template&id=4aeb1c0c&scoped=true&"
import script from "./RadioQuestion.vue?vue&type=script&lang=js&"
export * from "./RadioQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RadioQuestion.vue?vue&type=style&index=0&id=4aeb1c0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb1c0c",
  null
  
)

export default component.exports